export default "__VITE_ASSET__DTAx5E55__"